import { render } from "./shareWidgetDialog.vue?vue&type=template&id=79ea4206"
import script from "./shareWidgetDialog.vue?vue&type=script&lang=js"
export * from "./shareWidgetDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__